const ACCESS_DENIED_CODES = [
  'account_deactivated',
  'user_not_provisioned',
  'tenant_not_enabled',
  'api_access_not_enabled',
  'email_not_allowed',
];

// Codes whose copy is a single self-contained message (guide v1.9 asks to
// show it as-is), so they have a title key only.
const SINGLE_MESSAGE_CODES = [
  'user_not_provisioned',
  'tenant_not_enabled',
  'api_access_not_enabled',
  'email_not_allowed',
];

// i18n keys for the 403 access states. Any other code keeps the generic
// "not enabled" copy. `body` is null when the state has no second paragraph.
export const getAccessCopyKeys = (code) => {
  if (!ACCESS_DENIED_CODES.includes(code)) {
    return {
      body: 'persons.nawiChat.notEnabled.body',
      title: 'persons.nawiChat.notEnabled.title',
    };
  }
  return {
    body: SINGLE_MESSAGE_CODES.includes(code)
      ? null
      : `persons.nawiChat.accessDenied.${code}.body`,
    title: `persons.nawiChat.accessDenied.${code}.title`,
  };
};
